module.exports = __webpack_public_path__ + "static/media/cryptoIcon.2aa83696.png";